import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Eye, Lock } from 'lucide-react';

interface SharedProjectBannerProps {
  ownerUsername: string;
  ownerUserId: number;
  viewCount: number;
  projectName?: string;
}

const formatViewCountRange = (count: number): string => {
  if (count === 0) return '0';
  if (count < 10) return '< 10';
  if (count < 50) return '10+';
  if (count < 100) return '50+';
  if (count < 500) return '100+';
  if (count < 1000) return '500+';
  if (count < 5000) return '1K+';
  if (count < 10000) return '5K+';
  return '10K+';
};

const SharedProjectBanner: React.FC<SharedProjectBannerProps> = ({
  ownerUsername,
  ownerUserId,
  viewCount,
  projectName,
}) => {
  const location = useLocation();

  return (
    <div className="banner bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg px-4 py-3 flex items-center justify-between">
      <div className="flex items-center gap-2 text-sm text-blue-800 dark:text-blue-300">
        <Link
          to={`/users/${ownerUserId}`}
          state={projectName ? { from: location.pathname, fromLabel: projectName } : undefined}
          className="font-medium hover:underline"
        >{`Shared by @${ownerUsername}`}</Link>
        <span className="inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium rounded-full bg-blue-100 dark:bg-blue-800/40 text-blue-700 dark:text-blue-300">
          <Lock className="w-3 h-3" aria-hidden="true" />
          Read Only
        </span>
      </div>

      <div className="flex items-center gap-1 text-sm text-blue-700 dark:text-blue-400">
        <Eye className="w-4 h-4" aria-hidden="true" />
        <span>{formatViewCountRange(viewCount)} views</span>
      </div>
    </div>
  );
};

export default SharedProjectBanner;
